import SearchResultsTabProducts from '../components/search/SearchResultsTabProducts.vue';
import SearchResultsTabArticles from '../components/search/SearchResultsTabArticles.vue';
import SearchResultsTabServices from '../components/search/SearchResultsTabServices.vue';
import SearchResultsTabStores from '../components/search/SearchResultsTabStores.vue';

export const TAB_ALL = 'all';
export const TAB_PRODUCTS = 'products';
export const TAB_STORES = 'stores';
export const TAB_ARTICLES = 'articles';
export const TAB_SERVICES = 'services';

export const TABS_ORDER = [TAB_PRODUCTS, TAB_ARTICLES, TAB_SERVICES, TAB_STORES];

export const URL_QUERY_SEARCH_NAME = 'keyword';
export const URL_FILTERS_SEARCH_NAME = 'search';
export const MIN_TERM_LENGTH = 3;
export const SEARCH_QUERY_DELAY = 1000;
export const SEARCH_QUERY_SUGGESTION_DELAY = 600;

export const getTabComponent = (tab) => {
  switch (tab) {
    case TAB_PRODUCTS:
      return SearchResultsTabProducts;
    case TAB_ARTICLES:
      return SearchResultsTabArticles;
    case TAB_SERVICES:
      return SearchResultsTabServices;
    case TAB_STORES:
      return SearchResultsTabStores;
    default:
      throw new Error(`[Search] Tab '${tab}' is not supported`);
  }
};
